import {
  createStyles,
  Menu,
  Center,
  Header,
  Container,
  Group,
  Button,
  Burger,
  rem,
  Image
} from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";
import logo from './Data4Research-logos/Data4Research-logos_black.png'
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { withTrackingParams, consentPath } from "./trackingParams";
import './header.css'
const HEADER_HEIGHT = rem(60);

const useStyles = createStyles((theme) => ({
  inner: {
    height: HEADER_HEIGHT,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  links: {
    [theme.fn.smallerThan("sm")]: {
      display: "none",
    },
  },

  burger: {
    [theme.fn.largerThan("sm")]: {
      display: "none",
    },
  },

  link: {
    display: "block",
    lineHeight: 1,
    padding: `${rem(8)} ${rem(12)}`,
    borderRadius: theme.radius.sm,
    textDecoration: "none",
    color:
      theme.colorScheme === "dark"
        ? theme.colors.dark[0]
        : theme.colors.gray[7],
    fontSize: theme.fontSizes.sm,
    fontWeight: 500,

    "&:hover": {
      backgroundColor:
        theme.colorScheme === "dark"
          ? theme.colors.dark[6]
          : theme.colors.gray[0],
    },
  },

  linkLabel: {
    marginRight: rem(5),
  },
}));



export function HeaderAction({ links }) {
  const { classes } = useStyles();
  // Subscribing to the location re-renders the header on in-app navigation,
  // so its links always carry the current tracking params.
  const { search } = useLocation();
  const [openedLink, setOpenedLink] = useState(null);
   const handleLinkClick = (index) => {
    if (openedLink === index) {
      setOpenedLink(null);
    } else {
      setOpenedLink(index);
    }
  };
   const handleMenuItemClick = (url) => {
     setOpenedLink(null);
     window.location.href = url;
   };
  const items = links.map((link) => {
    const menuItems = link.links?.map((item) => (
      <Menu.Item key={item.link} onClick={() => handleMenuItemClick(withTrackingParams(item.link, search))}>
        {item.label}
      </Menu.Item>
    ));

    if (menuItems) {
      return (
        <Menu
          key={link.label}
          trigger="hover"
          transitionProps={{ exitDuration: 0 }}
          withinPortal
        >
          <Menu.Target>
            <a
              href={withTrackingParams(link.link, search)}
              className={classes.link}
            >
              <Center>
                <span className={classes.linkLabel}>{link.label}</span>
                <IconChevronDown size={rem(12)} stroke={1.5} />
              </Center>
            </a>
          </Menu.Target>
          <Menu.Dropdown>{menuItems}</Menu.Dropdown>
        </Menu>
      );
    }

    return (
      <a
        key={link.label}
        href={withTrackingParams(link.link, search)}
        className={classes.link}
      >
        {link.label}
      </a>
    );
  });

  return (
    <Header height={HEADER_HEIGHT} sx={{ borderBottom: 0 }} className="header">
      <Container className={classes.inner} fluid>
        <Group>
          <Burger
            opened={openedLink === "burger"}
            onClick={() => handleLinkClick("burger")}
            className={classes.burger}
            size="sm"
          />
          <Image width={150} src={logo} />
        </Group>
        <Group spacing={5} className={classes.links}>
          {items}
        </Group>
        <Button
          radius="xl"
          h={30}
          onClick={() => (window.location.href = consentPath(search))}
        >
          Donate Now!
        </Button>
      </Container>
    </Header>
  );
}
